var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiltersSolid1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 17.5a.5.5 0 0 1-.5.5H19v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V18h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h.5v-5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V16h.5a.5.5 0 0 1 .5.5zm-6-4a.5.5 0 0 1-.5.5H13v5.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V14h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h.5v-1.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V12h.5a.5.5 0 0 1 .5.5zM22 7H8a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1"
})));
export default SvgFiltersSolid1;